import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import OrderController, {
  StoreOrderType,
} from "../../controller/OrderController";
import {
  cartPayInfo,
  cartPayInfoState,
  cartProductQuantityState,
  cartState,
  inquiryState,
} from "../../recoil/cart";
import {
  LANG_CH,
  LANG_EN,
  LANG_JP,
  LANG_KO,
  LANG_TH,
  langState,
  langText,
  langTextBestDiscount,
} from "../../recoil/lang";
import {
  CouponType,
  orderDetailRealmType,
  paymentRealmType,
  postMessageType,
  PRODUCT_TYPE_DELIVERY,
  PRODUCT_TYPE_RENTAL_SMS,
} from "../../recoil/type";
import "../../styles/CustomModal.css";
import { getDecryptObject, getEncryptObject } from "../../utils/crypto";
import ConfirmModal from "./ConfirmModal";
import { useToast } from "../../controller/ToastController";
import MessageController from "../../controller/MessageController";
import { getRecoil, setRecoil } from "recoil-nexus";
import { DiscountType, storeType } from "../../controller/StoreController";
import ApiController from "../../controller/ApiController";
import {
  authState,
  authStoreType,
  authType,
  masterStoreState,
} from "../../recoil/auth";
import {
  contentName,
  getOptionName,
  getOptionTypeName,
  getPrdName,
  getProductName,
} from "../../utils/util";
import { settingsState } from "../../recoil/settings";
import { showKeyboardState } from "../../recoil/showKeyboard";
import { EventType } from "../../controller/MasterController";
import { eventState } from "../../recoil/event";
import LogController from "../../controller/LogController";
import SpeechBubble from "../SpeechBubble";

type Props = {
  modalIsVisible: boolean;
  modalSetVisible: any;
  resetTimer: any;
  couponList: CouponType[];
  visibleCouponList: CouponType[];
  unavailableCouponList: CouponType[];
  visibleClosed: boolean;
  setVisibleClosed: any;
  setCouponList: any;
  setVisibleCouponList: any;
  setUnavailableCouponList: any;
  setVisibleCustomerInfoModal: any;
  orderInfo: StoreOrderType;
  discount: DiscountType;
  realPayPrice: number;
  doPayment: any;
  number: string;
  email: string;
  setNumber: (number: string) => void;
  setEmail: (email: string) => void;
  visibleCustomerInfoModal: boolean;
  setVisibleRoomNumberModal: any;
  visibleRoomNumberModal: boolean;
  areaNumber: number;
  roomNumber: number;
  setVisiblePaymentDelay: (visiblePaymentDelay: boolean) => void;
  weatherNotice: string;
  paymentReady: any;
  setPaymentReady: any;
  checkVisibleSpeechBubble: () => boolean;
  bestDiscount: { required: number; discount: number };
};

// interface CustomTextareaProps
//   extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
//   enterKeyHint?:
//     | "enter"
//     | "done"
//     | "go"
//     | "next"
//     | "previous"
//     | "search"
//     | "send";
// }

let timeout: any;

const PaymentListModal = ({
  modalIsVisible,
  modalSetVisible,
  resetTimer,
  couponList,
  visibleCouponList,
  unavailableCouponList,
  visibleClosed,
  setVisibleClosed,
  setCouponList,
  setVisibleCouponList,
  setUnavailableCouponList,
  setVisibleCustomerInfoModal,
  orderInfo,
  discount,
  realPayPrice,
  doPayment,
  number,
  email,
  setNumber,
  setEmail,
  visibleCustomerInfoModal,
  visibleRoomNumberModal,
  setVisibleRoomNumberModal,
  areaNumber,
  roomNumber,
  setVisiblePaymentDelay,
  weatherNotice,
  paymentReady,
  setPaymentReady,
  checkVisibleSpeechBubble,
  bestDiscount,
}: Props) => {
  const settings = useRecoilValue(settingsState);
  const kioskMode = settings.view.kioskmode.value === "1";
  const cart = useRecoilValue<orderDetailRealmType[]>(cartState);
  const cartPay = useRecoilValue<cartPayInfo>(cartPayInfoState);
  const cartQuantitiy = useRecoilValue<number>(cartProductQuantityState);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const textareaRef = useRef<any>(null);
  const [onKeyboard, setOnKeyboard] = useState<boolean>(false);
  const [showKeyboard, setShowKeyboard] = useRecoilState(showKeyboardState);

  const [requestChecked1, setRequestChecked1] = useState<boolean>(true);
  const [requestChecked2, setRequestChecked2] = useState<boolean>(true);
  const [requestText, setRequestText] = useState<string>("");
  const master = useRecoilValue<authStoreType | null>(masterStoreState);

  const [couponCode, setCouponCode] = useState<string>("");

  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const isButtonDisabledRef = useRef<boolean>(isButtonDisabled);
  const auth = useRecoilValue<authType>(authState);

  const navigate = useNavigate();
  const lang = useRecoilValue<number>(langState);
  const onCloseButton = () => {
    setVisibleConfirm(true);
    setIsButtonDisabled(false);
  };
  const onCloseClosedConfirm = (value: boolean) => {
    setVisibleClosed(value);
    modalSetVisible(false);
    navigate("/master");
  };
  const showToast = useToast();

  const handleCheckboxToggle = (checkboxNumber: number) => {
    if (checkboxNumber === 1) {
      setRequestChecked1(!requestChecked1);
    } else if (checkboxNumber === 2) {
      setRequestChecked2(!requestChecked2);
    }
  };
  const handleCouponCodeChange = (event: any) => {
    setCouponCode(event.target.value);
  };
  const handleTextareaChange = (event: any) => {
    const inputText = event.target.value;
    if (inputText.length <= 80) {
      setRequestText(inputText);
    } else {
      showToast(langText.paymentListModal_toast_exceed[lang], "error");
    }
  };
  const startEvent = async () => {
    const eventData = await getEventList();

    if (eventData && eventData.used === 0) {
      openEvent(eventData);
    }
  };
  const openEvent = (eventData: EventType) => {
    LogController.click({
      path: "PaymentListModal",
      params: "event",
      params2: "틀린그림찾기 이벤트 클릭",
    });

    setRecoil(eventState, {
      ...eventData,
      visible: true,
      coupon: null,
    });
  };
  const getEventList = async () => {
    const user_id = getRecoil(authState).user_id;
    const user_token_id = getRecoil(authState).user_token_id;

    try {
      const response = await ApiController.store.getEventList(
        user_id,
        user_token_id
      );

      if (response && response.data) {
        const oRes = response.data;
        const eventData = oRes.data.filter(
          (item: EventType) => item.event_type === 2 && item.used === 0
        );
        if (eventData.length > 0) {
          return eventData[Math.floor(Math.random() * eventData.length)];
        } else {
          return null;
        }
      }
    } catch (err) {
      console.log("getAdverList err-->", err);
    }
  };
  const RenderPaymentList = () => {
    return (
      <div className={`paymentListWrap ${onKeyboard && "input"}`}>
        {cart.map((product, index) => (
          <div key={index} className="menuContent">
            <div className="orderIndex">
              <p>{index + 1}</p>
            </div>
            <div className="orderList">
              <div className="orderTitle">
                <div className="menuNameWrap">
                  <div
                    className={
                      product.product_discount_amount > 0
                        ? "menuNameShot"
                        : "menuName"
                    }
                  >
                    <h3>{getProductName(product, lang)}</h3>
                  </div>
                  {product.product_discount_amount > 0 && (
                    <div className="badge">
                      <h3>
                        {product.prdouct_discount_percentage}%{" "}
                        {langText.discount[lang]}
                      </h3>
                    </div>
                  )}
                </div>

                <h3 className="menuCount">{product.product_quantity}</h3>
                <h3 className="menuPrice">
                  {product.product_total_amount.toLocaleString()}원
                </h3>
              </div>
              {product.options?.map((option, index) => (
                <div key={index} className="orderOption">
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                    alt="옵션아이콘"
                  />
                  <div className="optionCategory">
                    <span>&#91;</span>
                    <p className="optionCategoryName">
                      {getOptionTypeName(option, lang)}
                    </p>
                    <span>&#93;</span>
                  </div>
                  <p className="optionName">{getOptionName(option, lang)}</p>
                  {/* <p className="optionPrice">
                    {option.option_price.toLocaleString()}원
                  </p> */}
                </div>
              ))}
              {product.set_product.map((set_product, prd_group_index) => (
                <div className="optionLine">
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                    alt="옵션아이콘"
                  />

                  {set_product.input_min > 0 ? (
                    <p className="optionCategoryName">
                      [{langText.setOptionModal_configuration[lang]}
                      {prd_group_index + 1}]
                    </p>
                  ) : (
                    <p className="optionCategoryName">
                      [{langText.setOptionModal_addtional[lang]}]
                    </p>
                  )}
                  <div className="optionCategory">
                    {set_product.pick.map((pickProduct, prd_index) => (
                      <div className="setOrderOption" key={prd_index}>
                        <div className="optionLineChild">
                          <p>{getPrdName(pickProduct, lang)}</p>
                          {pickProduct.pick.length > 0 && (
                            <div className="optionBreak">
                              <div className="optionBreakLine"></div>
                              <h5>({langText.setOptionModal_option[lang]})</h5>
                            </div>
                          )}
                          <div className="setOptionPickOption">
                            {pickProduct.pick.map((pickOptionGroup, index) =>
                              pickOptionGroup.map((pickOption, opt_index) => (
                                <span key={opt_index}>
                                  {getOptionName(
                                    pickProduct.option_group_list[index]
                                      ?.option_list[pickOption],
                                    lang
                                  )}
                                </span>
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        <ConfirmModal
          isVisible={visibleConfirm}
          setVisible={setVisibleConfirm}
          title={langText.confirmModal_cancelPayment[lang]}
          confirmText={langText.button_yes[lang]}
          cancelText={langText.button_no[lang]}
          onConfirm={() => {
            try {
              LogController.click({
                path: "PaymentListModal",
                params: "click",
                params2: `결제취소 클릭`,
                store_id:
                  getRecoil(cartState).length > 0
                    ? getRecoil(cartState)[0].store_id
                    : 0,
                index:
                  getRecoil(cartState).length > 0
                    ? getRecoil(cartState)[0].store_id
                    : 0,
              });
            } catch (err) {
              console.log(err);
            }

            window.ReactNativeWebView?.postMessage(
              MessageController.getOrderCompleteData()
            );
            setVisibleConfirm(false);
            modalSetVisible(false);
            startEvent();
          }}
        />
        <ConfirmModal
          isVisible={visibleClosed}
          setVisible={onCloseClosedConfirm}
          title={langText.confirmModal_closed[lang]}
          confirmText={langText.button_home[lang]}
        />
      </div>
    );
  };

  const onClickPayButton = async () => {
    if (orderInfo.limit_order_price > cartPay.total_amount_incl) {
      //TODO 최소주문금액
      showToast(
        `${
          lang === LANG_KO || lang === LANG_JP
            ? `${orderInfo.limit_order_price.toLocaleString()}원`
            : ""
        }${langText.paymentListModal_button_order_limit[lang]} ${
          lang === LANG_EN || lang === LANG_CH || lang === LANG_TH
            ? `${orderInfo.limit_order_price.toLocaleString()}원`
            : ""
        }`,
        "error"
      );

      try {
        LogController.click({
          path: "PaymentListModal",
          params: "click",
          params2: `최소주문금액 미달 => 구매금액: ${cartPay.total_amount_incl}, 최소주문금액: ${orderInfo.limit_order_price}`,
          store_id: cart.length > 0 ? cart[0].store_id : 0,
          index: cartPay.total_amount_incl,
        });
      } catch (err) {
        console.log(err);
      }
      return;
    }

    if (cartPay.total_amount_incl >= orderInfo.limit_order_price) {
      if (isButtonDisabledRef.current) return;
      setIsButtonDisabled(true);
      isButtonDisabledRef.current = true;

      if (cart[0].product_type === PRODUCT_TYPE_RENTAL_SMS) {
        modalSetVisible(false);
        setVisibleCustomerInfoModal(true);
      } else if (kioskMode) {
        modalSetVisible(false);
        setVisibleRoomNumberModal(true);
      } else {
        setPaymentReady(true);
        doPayment();
      }
    }
  };
  const sendOrder = async (payResult: paymentRealmType) => {
    const cart = getRecoil(cartState);
    const cartPay = getRecoil(cartPayInfoState);

    console.log(
      "props===============>",
      orderInfo,
      number,
      email,
      areaNumber,
      roomNumber
    );

    let res = await OrderController.sendOrder(
      cart,
      cartPay,
      payResult,
      textareaRef.current === null ? "" : textareaRef.current.value,
      orderInfo,
      discount,
      cart[0].product_type === PRODUCT_TYPE_RENTAL_SMS && number.length > 0
        ? number
        : undefined,
      cart[0].product_type === PRODUCT_TYPE_RENTAL_SMS && email.length > 0
        ? email
        : undefined
    );

    if (res.ok) {
      // setPaymentReady(false);
      setRecoil(cartState, []);
      navigate("/status");

      // showToast(langText.payment_completed[lang], "success", 5000);
    } else {
      //! TODO  에러처리: 취소 모듈 호출 필요. 만약 취소 호출마저 고객이 취소 또는 취소실패하면?

      // window.ReactNativeWebView?.postMessage(
      //   MessageController.getPayCancelRequestData(payResult)
      // );
      LogController.error({
        path: "PaymentListModal",
        params: "error",
        params2: "sendOrder 오류",
      });
      // setPaymentReady(false);
      showToast("ERROR", "error");
    }
  };

  const handleOrder = async (event: any) => {
    LogController.event({
      path: "PaymentListModal",
      params: "handleOrder",
      params2: `결제내역 이벤트 확인:${event.data.toString()}`,
    });

    let message = getDecryptObject(event.data);
    if (message.type !== "pay_result") {
      return;
    }

    try {
      if (timeout === null) {
        // showToast("delay error", "error");
        return;
      }

      // let message = getDecryptObject(event.data);

      // if (message.type === "pay_result") {
      let payResult: paymentRealmType = message.data;

      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData({ payResult })
      );

      if (payResult.tran_result && "amount" in payResult) {
        await sendOrder(payResult);
      } else {
        const errorMsg = payResult.response_msg
          ? payResult.response_msg
          : "결제 오류입니다.";

        LogController.error({
          path: "PaymentListModal",
          params: "error",
          params2: `show error toast : ${errorMsg.slice(0, 300)}`,
        });

        showToast(errorMsg, "error", 3000);
      }
      // }
    } catch (err: any) {
      LogController.error({
        path: "PaymentListModal",
        params: "error",
        params2: `handleOrder 오류: ${err.toString().slice(0, 300)}`,
      });

      window.ReactNativeWebView?.postMessage(
        getEncryptObject({
          type: "error",
          data: err,
        })
      );
    } finally {
      setIsButtonDisabled(false);
      setPaymentReady(false);
      window.ReactNativeWebView?.postMessage(
        MessageController.getOrderCompleteData()
      );
    }
  };

  useEffect(() => {
    isButtonDisabledRef.current = isButtonDisabled;
  }, [isButtonDisabled]);
  useEffect(() => {
    setRequestText("");
  }, [modalIsVisible]);

  useEffect(() => {
    if (showKeyboard.input.length <= 80) {
      setRequestText(showKeyboard.input);
    } else {
      showToast(langText.paymentListModal_toast_exceed[lang], "error");
    }
  }, [showKeyboard]);

  React.useEffect(() => {
    if (modalIsVisible) {
      setCouponCode("");
    } else {
      setCouponList([]);
      setVisibleCouponList([]);
      setUnavailableCouponList([]);
      setCouponCode("");
      setIsButtonDisabled(false);
      isButtonDisabledRef.current = false;
    }
  }, [modalIsVisible]);

  React.useEffect(() => {
    // TODO
    /**
     *
     *  paymentListModal->cartInfo 구조에서 cartInfo 랜더링시
     *  리스너가 등록되는 문제로 인해
     *  paymentListModal이 열림 됐을때만 리스너 등록.
     *
     *  */
    if (modalIsVisible || visibleCustomerInfoModal || visibleRoomNumberModal) {
      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData({
          d: "paymentList 이벤트 등록@@@@@@@@@@@@@@@@@",
        })
      );
      document.addEventListener("message", handleOrder);
    }

    return () => {
      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData({
          d: "paymentList 이벤트 해제 XXXXXXXXXXXXXXXXXXXXXXXXX",
        })
      );
      document.removeEventListener("message", handleOrder);
    };
  }, [
    discount,
    orderInfo,
    modalIsVisible,
    number,
    email,
    areaNumber,
    roomNumber,
    visibleRoomNumberModal,
  ]);

  useEffect(() => {
    const textarea = textareaRef.current;

    if (textarea) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [requestText]);

  useEffect(() => {
    if (paymentReady) {
      timeout = setTimeout(() => {
        setPaymentReady(false);
        setVisiblePaymentDelay(true);

        setIsButtonDisabled(false);
        window.ReactNativeWebView?.postMessage(
          MessageController.getOrderCompleteData()
        );
      }, 60 * 1000);
    } else {
      clearTimeout(timeout);
      timeout = null;
    }
  }, [paymentReady]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // Enter 키의 기본 동작을 막음 (예: 줄 바꿈)
      if (textareaRef.current) {
        textareaRef.current.blur(); // 포커스를 제거하여 키보드를 닫습니다.
      }
    }
  };

  const onClickCouponCode = async () => {
    if (master) {
      const res = await ApiController.store.getCouponCode({
        store_id: cart[0].store_id,
        parent_store_id: master.store_id,
        user_token_id: auth.user_token_id,
        price: cartPay.total_amount_incl,
        coupon_code: couponCode,
      });

      console.log(res.data);

      if (res.ok && res.data.length > 0) {
        const couponCodeList: CouponType[] = res.data;
        let availableCoupons: CouponType[] = [
          ...couponList.filter(
            (coupon) => coupon.coupon_type !== 2 && coupon.duplicate_user !== 1
          ),
        ];

        let visibleCoupons: CouponType[] = [
          ...visibleCouponList.filter(
            (coupon) => coupon.coupon_type !== 2 && coupon.duplicate_user !== 1
          ),
        ];

        // let unavailableCoupons: CouponType[] = unavailableCouponList;

        let dupleCoupon: CouponType[] = [
          ...couponList.filter(
            (coupon) => coupon.coupon_type !== 2 && coupon.duplicate_user === 1
          ),
        ];

        for (let i = 0; i < dupleCoupon.length; i++) {
          const dc = dupleCoupon[i];
          visibleCoupons.push(dc);
        }

        for (let coupon of couponCodeList) {
          if (coupon.requirement > cartPay.total_amount_incl) {
            showToast(
              `${langText.coupon_name[lang]} ${
                langText.menuInfo_base_delivery_price[lang]
              } ${coupon.requirement.toLocaleString()}원`,
              "error"
            );
            return;
          }

          availableCoupons.push(coupon);
          visibleCoupons.push(coupon);
        }

        if (couponList.filter((coupon) => coupon.coupon_type === 2).length > 0)
          showToast(
            langText.paymentListModal_toast_already_coupon[lang],
            "error"
          );
        else {
          showToast(langText.paymentListModal_toast_add_coupon[lang]);
        }

        setCouponList(availableCoupons);
        setVisibleCouponList(visibleCoupons);
      } else {
        showToast(
          langText.paymentListModal_toast_coupon_code_error[lang],
          "error"
        );
      }
    }
  };

  return (
    <Modal
      open={modalIsVisible}
      onClose={onCloseButton}
      center
      classNames={{
        overlay: "paymentListOverlay",
        modal: `paymentListCustomModal ${onKeyboard && "input"}`,
      }}
      showCloseIcon={false}
      animationDuration={150}
      closeOnOverlayClick={false}
    >
      <Style>
        <div
          className="paymentModalWrap"
          onTouchStart={resetTimer}
          onScrollCapture={resetTimer}
        >
          <div className="modalHeader">
            <h3>{langText.paymentListModal_title_name[lang]}</h3>
            <div className="row gap">
              <div className="badge">
                <h3>{langText.paymentListModal_title_pickup_location[lang]}</h3>
                <h3>⮕</h3>
                <h3 className="pickupName">
                  {lang === 0
                    ? orderInfo.pickup_name
                    : orderInfo.pickup_name_en}
                </h3>
              </div>
              <button onClick={onCloseButton}>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_modalClose.svg`}
                  width={32}
                  height={32}
                  alt="닫기버튼"
                />
              </button>
            </div>
          </div>
          <RenderPaymentList />
          {/* 총결제금액 */}
          <div className="paymentContentWrap">
            <div className="totalOrder">
              <h2>{langText.paymentListModal_title_totalPayment[lang]}</h2>
              <h2 className="quantity">{cartQuantitiy}</h2>
              <h2>
                {realPayPrice >= 0 ? realPayPrice.toLocaleString() : `0`}원
              </h2>
            </div>
            <div className="totalWrap">
              <div className="totalContent">
                <h2>{langText.paymentListModal_title_productPrice[lang]}</h2>
                <h3>{cartPay.total_amount_org.toLocaleString()}원</h3>
              </div>
              {/* <div className="totalContent">
              <h2>{langText.paymentListModal_title_orderAmount[lang]}</h2>
              <h3>{cartPay.total_amount_incl.toLocaleString()}원</h3>
            </div> */}
              {cart.length > 0 &&
                cart[0].product_type === PRODUCT_TYPE_DELIVERY && (
                  <div className="totalContent">
                    <h2>
                      {langText.paymentListModal_title_delivery_cost[lang]}
                    </h2>
                    <h3>{orderInfo.base_delivery_price.toLocaleString()}원</h3>
                  </div>
                )}
              {/* TODO 번역  */}
              {cart.length > 0 &&
                cart[0].product_type === PRODUCT_TYPE_DELIVERY &&
                orderInfo.room_tip > 0 && (
                  <div className="totalContent">
                    <h2>{langText.room_tip[lang]}</h2>
                    <h3>{orderInfo.room_tip.toLocaleString()}원</h3>
                  </div>
                )}
              <div className="totalContent coupon">
                <h2>{langText.paymentListModal_title_coupon[lang]}</h2>
                <div className="row gap">
                  <input
                    value={couponCode}
                    onChange={handleCouponCodeChange}
                    placeholder={langText.paymentListModal_coupon_code[lang]}
                  />
                  <button onClick={onClickCouponCode}>
                    <h3>{langText.button_confirm[lang]}</h3>
                  </button>
                </div>
              </div>
              {/* 할인금액 */}
              {(discount.discountAmount + cartPay.discount_amount > 0 ||
                visibleCouponList.length > 0) && (
                <div className="totalContent">
                  <div className="row gap">
                    <h2>{langText.paymentListModal_title_discount[lang]}</h2>
                    <div className="badge">
                      <h3>
                        {langText.paymentListModal_maximum_discount[lang]} 🎉
                      </h3>
                    </div>
                  </div>
                  <h3>
                    {discount.discountAmount + cartPay.discount_amount > 0
                      ? `-${(
                          discount.discountAmount + cartPay.discount_amount
                        ).toLocaleString()}원`
                      : `0원`}
                  </h3>
                </div>
              )}
              <div className="couponWrap">
                {(discount.discountAmount + cartPay.discount_amount > 0 ||
                  visibleCouponList.length > 0) && (
                  <div>
                    {cartPay.discount_amount > 0 && (
                      <div className="totalContent discount">
                        <div className="row gap">
                          <img
                            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                            alt="옵션아이콘"
                          />
                          <h4>
                            {
                              langText.paymentListModal_title_product_discount[
                                lang
                              ]
                            }
                          </h4>
                        </div>
                        <h4>-{cartPay.discount_amount.toLocaleString()}원</h4>
                      </div>
                    )}
                    {visibleCouponList.length > 0 && (
                      <div className="totalContent discount coupon">
                        <div className="row gap">
                          <img
                            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                            alt="옵션아이콘"
                          />
                          <h4>
                            {
                              langText.paymentListModal_title_coupon_discount[
                                lang
                              ]
                            }
                          </h4>
                        </div>
                        <div className="couponListWrap">
                          {visibleCouponList.map((item, index: number) => {
                            const discountCoupon = discount.couponList.find(
                              (obj) => obj.coupon_id === item.coupon_id
                            );

                            return (
                              <div key={index} className="discountInfo">
                                <div className="couponName">
                                  <h4>•{item.coupon_name}</h4>
                                </div>
                                <div className="row">
                                  {discountCoupon && (
                                    <h4>
                                      -
                                      {(
                                        discountCoupon.com_discount_amount +
                                        discountCoupon.store_discount_amount
                                      ).toLocaleString()}
                                      원
                                    </h4>
                                  )}
                                  <button
                                    className="checkBox"
                                    onClick={() => {
                                      // console.log(discountCoupon);
                                      if (discountCoupon) {
                                        //쿠폰이 있는경우
                                        const coupons = [
                                          ...couponList.filter(
                                            (c) =>
                                              c.coupon_id !== item.coupon_id
                                          ),
                                        ];
                                        setCouponList(coupons);
                                      } else {
                                        if (item.duplicate_user === 1) {
                                          const coupons = couponList.filter(
                                            (c) => c.duplicate_user !== 1
                                          );
                                          coupons.push(item);
                                          setCouponList(coupons);
                                        } else if (item.duplicate_user === 2) {
                                          const coupons = couponList.filter(
                                            (c) => c.duplicate_user !== 2
                                          );
                                          coupons.push(item);
                                          setCouponList(coupons);
                                        } else {
                                          const coupons = [...couponList, item];
                                          setCouponList(coupons);
                                        }
                                      }
                                    }}
                                  >
                                    {discountCoupon && (
                                      <img
                                        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_mint.svg`}
                                        alt="체크박스"
                                      />
                                    )}
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {/* 사용불가쿠폰 */}
                {unavailableCouponList.length > 0 && (
                  <div className="totalContent discount coupon unavailable">
                    {unavailableCouponList.map((item, index: number) => (
                      <div className="discountInfo unavailable">
                        <div className="couponName">
                          <h4>•{item.coupon_name}</h4>
                        </div>
                        <div className="unavailableNotive">
                          {item.requirement.toLocaleString()}
                          {langText.paymentListModal_unavailable_notice[lang]}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="orderRequest">
                <h3>{langText.paymentListModal_title_request[lang]}</h3>
                {/* <div className="requestCheckbox">
                <label htmlFor="requestChecked1">
                  <input
                    type="checkbox"
                    id="requestChecked1"
                    checked={requestChecked1}
                    onChange={() => handleCheckboxToggle(1)}
                  />
                  <span>
                    KNOCK KNOCK{" "}
                    {langText.paymentListModal_title_thblecloth[lang]}
                  </span>
                </label>

                <label htmlFor="requestChecked2">
                  <input
                    type="checkbox"
                    id="requestChecked2"
                    checked={requestChecked2}
                    onChange={() => handleCheckboxToggle(2)}
                  />
                  <span>
                    KNOCK KNOCK{" "}
                    {langText.paymentListModal_title_clean_bag[lang]}
                  </span>
                </label>
              </div> */}
                {lang === 0 ? (
                  <textarea
                    onKeyDown={handleKeyDown}
                    ref={textareaRef}
                    placeholder={langText.paymentListModal_placeholder[lang]}
                    value={requestText}
                    onFocus={() => setOnKeyboard(true)}
                    onBlur={() => setOnKeyboard(false)}
                    onChange={handleTextareaChange}
                  />
                ) : (
                  <div
                    ref={textareaRef}
                    onClick={() =>
                      setShowKeyboard((prev) => ({
                        ...prev,
                        showKeyboard: true,
                        input: requestText,
                      }))
                    }
                    className="textarea"
                  >
                    {requestText || langText.paymentListModal_placeholder[lang]}
                  </div>
                )}
              </div>
              <p className="notice">{weatherNotice}</p>
            </div>
            <div className="modalFooter">
              <button className="paymentCancel" onClick={onCloseButton}>
                <h2>{langText.button_cancel[lang]}</h2>
              </button>
              <button
                className={`paymentSuccess ${
                  cartPay.total_amount_incl < orderInfo.limit_order_price &&
                  "unabled"
                }`}
                disabled={isButtonDisabledRef.current}
                onClick={onClickPayButton}
              >
                <h2>{`${
                  cartPay.total_amount_incl < orderInfo.limit_order_price
                    ? `${
                        lang === LANG_KO || lang === LANG_JP
                          ? `${orderInfo.limit_order_price.toLocaleString()}원`
                          : ""
                      }${langText.paymentListModal_button_order_limit[lang]} ${
                        lang === LANG_EN || lang === LANG_CH || lang === LANG_TH
                          ? `${orderInfo.limit_order_price.toLocaleString()}원`
                          : ""
                      }`
                    : langText.paymentListModal_button_payment[lang]
                }`}</h2>
              </button>
              {checkVisibleSpeechBubble() && (
                <div className="speechBubbleWrap">
                  <SpeechBubble
                    title={
                      langTextBestDiscount(
                        (
                          bestDiscount.required - cartPay.total_amount_incl
                        ).toLocaleString(),
                        bestDiscount.discount.toLocaleString()
                      )[lang]
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {paymentReady && (
          <div className="toastWrap">
            <div className="customToastWrap">
              <div className="customToast">
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_error.svg`}
                  alt="search"
                />
                <p className="toastMessage">{langText.payment_ready[lang]}</p>
              </div>
            </div>
          </div>
        )}
      </Style>
    </Modal>
  );
};

export default PaymentListModal;

const Style = styled.div`
  /* paymentModalWrap */
  .paymentModalWrap {
    max-height: 95vh;
    display: flex;
    flex-direction: column;
  }

  .badge {
    padding: 4px 15px 2px 15px;
    border-radius: 50px;
    background: linear-gradient(90deg, #4ed2af 0%, #90c2e6 100%);

    h3 {
      white-space: nowrap;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
    }
  }
  .row {
    display: flex;
    align-items: center;
  }
  .row.gap {
    gap: 10px;
  }

  /* modalHeader */
  .modalHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 36px;

    h3 {
      font-size: 24px;
      font-weight: 500;
    }
    .badge {
      margin-right: 10px;
      padding: 4px 20px 2px 20px;
      display: flex;
      align-items: center;
      background: #ff6262;
      gap: 6px;
      border-radius: 10px;

      h3 {
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
      }
      h3.pickupName {
        white-space: normal;
        word-break: break-all;
        max-width: 60%;
      }
    }
    button {
      padding: 0;
    }
  }

  /* paymentListWrap */
  .paymentListWrap {
    width: 100%;
    min-height: 30vh;
    max-height: 30vh;
    flex: 1;
    padding: 14px 36px;
    overflow-y: auto;
    background: #232323;
    border-bottom: 1px solid #555;
    border-top: 1px solid #555;
  }
  .paymentListWrap.input {
    min-height: calc(30vh - 120px);
    max-height: calc(30vh - 120px);
  }

  /* .menuContent {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0;

    .orderIndex {
      margin-right: 8px;
      margin-top: 8px;
      border: 1px solid #555555;
      border-radius: 4px;

      p {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 8px 3px 8px;
        color: #e5e5e5;
        font-size: 12px;
        font-weight: 300;
      }
    }
  } */

  /* paymentContentWrap */
  .paymentContentWrap {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .menuContent {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    .orderIndex {
      margin-right: 8px;
      margin-top: 8px;
      border: 1px solid #555555;
      border-radius: 4px;

      p {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 8px 3px 8px;
        color: #e5e5e5;
        font-size: 12px;
        font-weight: 300;
      }
    }
  }

  /* orderList */
  .orderList {
    width: 95%;
    padding: 10px 0;
    border-bottom: 1px solid #3d3d3d;

    .orderTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .orderMenu,
  .orderOption {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .orderOption {
    margin: 4px 0;
    justify-content: flex-start;

    p {
      font-size: 16px;
      font-weight: 300;
      color: #e5e5e5;
    }

    .optionCategory {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 5px;
      max-width: 25%;

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .optionName {
      flex: 0 0 80%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .optionPrice {
      flex: 0 0 23%;
      text-align: right;
      margin-left: auto;
    }
  }
  .menuNameWrap {
    flex: 0 0 50%;
    width: 50%;
    max-width: 300px;
    display: flex;
    align-items: center;
    padding: 2px 0;

    .badge {
      margin-left: 8px;
      padding: 0;
      background: none;
      h3 {
        color: #ff6262;
        padding: 0;
      }
    }
  }
  .menuNameShot,
  .menuName {
    display: flex;

    h3 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .menuNameShot {
    max-width: 60%;
  }
  .menuName {
    max-width: 100%;
  }
  .menuCount {
    flex: 0 0 10%;
    text-align: center;
  }
  .menuPrice {
    flex: 0 0 25%;
    text-align: right;
  }

  .optionLine {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin: 4px 0;

    .optionCategoryName,
    p {
      margin: 0 4px;
      font-size: 16px;
      font-weight: 300;
      color: #e5e5e5;
      flex: 0 0 16%;
    }
  }

  .optionBreak {
    display: flex;
    align-items: center;

    .optionBreakLine {
      border-right: 1px solid #fff;
      margin-right: 4px;
      height: 16px;
    }
    h5 {
      font-size: 12px;
      font-weight: 300;
      color: #e5e5e5;
      white-space: nowrap;
    }
  }
  .optionLineChild {
    flex: 1;
    max-width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    p {
      white-space: nowrap;
    }
    .optionLineGroup {
      width: 100%;
    }
    .setOptionPickOption {
      max-width: 350px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #e5e5e5;

      span {
        font-size: 12px;
        font-weight: 300;
        color: #e5e5e5;
        margin-left: 4px;
        margin-bottom: 1px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  /* totalWrap */
  .totalWrap {
    flex: 1;
    padding-top: 10px;
  }
  .totalContent,
  .totalOrder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    padding: 0 36px;

    h2,
    h3 {
      font-size: 20px;
      font-weight: 500;
    }
    .badge {
      h3 {
        font-size: 16px;
      }
    }
  }
  .totalOrder {
    h2 {
      font-size: 28px;
      font-weight: 600;
    }
    h2.quantity {
      margin-right: -16%;
    }
  }

  /* couponWrap */
  .couponWrap {
    max-height: 135px;
    margin-top: 5px;
    overflow-y: auto;
  }

  .totalContent.coupon {
    .row.gap {
      gap: 8px;
    }
    input {
      width: 180px;
      height: 36px;
      padding: 2px 16px;
      border-radius: 10px;
      background: none;
      border: 1px solid #9f9f9f;
      font-size: 20px;
      line-height: 30px;
      color: #ffffff;
    }
    button {
      border: 1px solid #4dd2ae;
      border-radius: 10px;
      padding: 2px 16px;
      h3 {
        font-size: 20px;
        line-height: 30px;
        color: #4dd2ae;
      }
    }
  }

  .totalContent.discount {
    margin-top: 8px;
    /* margin-right: 27px; */
    margin-left: 60px;
    justify-content: space-between;
    align-items: flex-start;

    .row.gap {
      gap: 6px;
    }
    h4 {
      font-size: 18px;
      line-height: 30px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .totalContent.discount.coupon {
    justify-content: space-between;
    margin: 0;
    margin-left: 60px;

    .couponListWrap {
      width: calc(75% - 10px);
    }
    .discountInfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .couponName {
      max-width: 70%;
    }
    h4 {
      color: #4dd2ae;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .unavailableNotive {
      color: #ff4a4a;
      font-weight: 600;
    }
    .checkBox {
      margin-left: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      padding: 0;
      border: 1px solid #4dd2ae;
      border-radius: 5px;
    }
  }

  .totalContent.discount.coupon.unavailable {
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .unavailable {
      width: 100%;
    }
    .unavailable .couponName {
      max-width: 70%;
      h4 {
        color: gray;
      }
    }
  }
  .totalOrder {
    margin: 0;
    padding: 18px 36px;
    background: #474747;
    border-bottom: 1px solid #555;
  }
  .orderRequest {
    margin: 0 36px;
    margin-top: 16px;
    padding-top: 10px;
    border-top: 1px solid #555;

    h2 {
      font-size: 24px;
      margin: 0;
    }
    h3 {
      margin-bottom: 8px;
      font-size: 20px;
      font-weight: 500;
    }
  }

  /* .commentBox {
    padding: 0 14px;
    margin-bottom: 6px;
    background: rgba(64, 151, 127, 0.5);
    border-radius: 50px;
    max-width: 100%;

    p {
      color: #ffffff;
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .commentBox:after {
    content: " ";
    height: 0;
    width: 0;
    left: 110px;
    position: absolute;
    border: 5px solid transparent;
    border-bottom-width: 0;
    border-top-color: rgba(64, 151, 127, 0.5);
  } */

  /* orderRequest */
  .orderRequest {
    .requestCheckbox,
    label {
      display: flex;
      align-items: center;
    }
    .requestCheckbox {
      margin: 11px 0 16px 0;
      justify-content: space-between;
    }
    input {
      margin-right: 10px;
      accent-color: #40977f;
    }
    h2 {
      font-size: 22px;
      font-weight: 500;
    }
    span {
      font-size: 16px;
      font-weight: 400;
      color: #e5e5e5;
    }
    textarea,
    .textarea {
      width: 100%;
      height: 60px;
      max-height: 60px;
      padding: 4px 16px;
      border-radius: 10px;
      background: none;
      border: 1px solid #9f9f9f;
      font-size: 20px;
      line-height: 26px;
      color: #ffffff;
      overflow-y: auto;
      white-space: normal;
      word-break: break-all;
    }
  }

  .modalFooter {
    position: relative;
    padding: 16px 36px 20px 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .paymentCancel {
      padding: 16px 33px;
      border: 2px solid #777;
      border-radius: 10px;

      h2 {
        font-size: 24px;
        font-weight: 600;
        color: #a7a7a7;
      }
    }
    .paymentSuccess {
      flex: 1;
      margin-left: 10px;
      padding: 17px;
      border-radius: 10px;
      background: #4dd2ae;
      h2 {
        font-weight: 600;
      }
    }
    .paymentSuccess.unabled {
      background: #cecece;
    }
  }

  p.notice {
    margin: 10px 36px;
    font-size: 18px;
    line-height: 24px;
    color: #ff4a4a;
    font-weight: 600;
  }

  .toastWrap {
    width: 90vw;
    height: 90vh;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 999999999;
    .customToastWrap {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .customToast {
      max-width: 90%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 30px;
      text-align: left;
      border-radius: 10px;
      background: #ffffff;
    }
    .toastMessage {
      font-size: 20px;
      margin: 0;
      margin-left: 18px;
      font-weight: 500;
      color: #555555;
    }
  }

  .speechBubbleWrap {
    position: absolute;
    top: -50px;
    right: 3%;
  }
`;
